export default {"src":"/_next/static/media/icon_user.19a3fbd2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};